import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

type TwilioTokenData = {
  fromPhoneNumber: string;
  toPhoneNumber: string;
};

type TwilioTokenResponse = {
  token: string;
  identity: string;
  edge: string;
};

const getTwilioToken = (data: TwilioTokenData) => {
  const request: Request = {
    url: ENDPOINTS.call.twilio.token,
    config: {
      method: 'POST',
      data: { data },
    },
  };

  return client(request);
};

export default function useGetTwilioToken() {
  return useMutation<
    Response<TwilioTokenResponse>,
    CronoError,
    TwilioTokenData
  >({
    mutationFn: getTwilioToken,
  });
}
